import React from 'react';
interface HeaderProps {
  title: string;
  subtitle?: string;
  children?: React.ReactNode;
}
export function Header({
  title,
  subtitle,
  children
}: HeaderProps) {
  return <header className="bg-white border-b border-gray-200 px-8 py-5" data-id="element-232">
      <div className="flex items-center justify-between" data-id="element-233">
        <div data-id="element-234">
          <h2 className="text-2xl font-bold text-gray-900" data-id="element-235">{title}</h2>
          {subtitle && <p className="mt-1 text-sm text-gray-500" data-id="element-236">{subtitle}</p>}
        </div>
        {children && <div className="flex items-center gap-3" data-id="element-237">{children}</div>}
      </div>
    </header>;
}